// dependencies
import React, { useState } from 'react';
import './Navbar.css';
import { NavLink } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { ImCross } from 'react-icons/im';

const Navbar = () => {
   const [click, setClick] = useState(false);

   const handleClick = () => setClick(!click);
   const Close = () => setClick(false);

   return (
      <div className="nav-wrapper">
         <div
            className={click ? 'main-container' : ''}
            onClick={() => Close()}
         />
         <nav className="navbar" onClick={(e) => e.stopPropagation()}>
            <div className="nav-container">
               <NavLink exact to="/" className="nav-logo">
                  <img src="/img/logo.png" alt="logo" />
               </NavLink>

               <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                  <li className="nav-item">
                     <NavLink
                        exact
                        to="/"
                        activeClassName="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                     >
                        HOME
                     </NavLink>
                  </li>
                  <li className="nav-item">
                     <NavLink
                        exact
                        to="/cgpacalculator"
                        activeClassName="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                     >
                        CGPA CALCULATOR
                     </NavLink>
                  </li>
                  <li className="nav-item">
                     <NavLink
                        exact
                        to="/about"
                        activeClassName="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                     >
                        ABOUT
                     </NavLink>
                  </li>
                  <li className="nav-item">
                     <NavLink
                        exact
                        to="/terms"
                        activeClassName="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                     >
                        TERMS
                     </NavLink>
                  </li>
                  <li className="nav-item">
                     <NavLink
                        exact
                        to="/contact"
                        activeClassName="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                     >
                        CONTACT
                     </NavLink>
                  </li>
                  <li className="nav-item">
                     <NavLink
                        exact
                        to="/feedback"
                        activeClassName="active"
                        className="nav-links"
                        onClick={click ? handleClick : null}
                     >
                        FEEDBACK
                     </NavLink>
                  </li>
               </ul>
               <div className="nav-icon" onClick={handleClick}>
                  <span>
                     {click ? (
                        <ImCross className="cross-icon" />
                     ) : (
                        <GiHamburgerMenu />
                     )}
                  </span>
               </div>
            </div>
         </nav>
      </div>
   );
};

export default Navbar;
